import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { MatListModule, MatListItem } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon'; 
import { TasksService } from '../services/tasks.service';
import { lastValueFrom } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ApiResponse } from '../services/tasks.service';
import { MatButtonModule } from '@angular/material/button';

import { LogViewerComponent } from '../log-viewer/log-viewer.component';
import { YamlViewerComponent } from '../yaml-viewer/yaml-viewer.component';


@Component({
  selector: 'app-details',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatCardModule,
    RouterLink,
    MatListModule,
    MatIconModule,
    MatListItem,
    CommonModule,
    MatButtonModule,
    LogViewerComponent,
    YamlViewerComponent
  ],
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss'
})
export class DetailsComponent {

  pipelineId: string | null = null;
  taskList: [ApiResponse] | null = null;

  currentView: 'log' | 'yaml' | null = null;
  selectedTaskLog: string = '';
  selectedTaskYaml: string = '';
  
  constructor(
    private route: ActivatedRoute,
    private tasksService: TasksService
  ) { }

  async ngOnInit(): Promise<void> {
    this.pipelineId = this.route.snapshot.paramMap.get('pipelineId');
    if (this.pipelineId != null){
      const response = await lastValueFrom(this.tasksService.getTasks(this.pipelineId));
      this.taskList = response;
    }
  }

  async viewTaskLog(pipelinerun: string | null, taskName: string): Promise<void> {    
    this.currentView = 'log';
    this.selectedTaskLog = `Loading...`;
    if (pipelinerun != null && taskName != null) {
      let response = await lastValueFrom(this.tasksService.getTaskLog(pipelinerun, taskName));
      this.selectedTaskLog = response;
    }
  }

  async viewTaskYaml(pipelinerun: string | null, taskName: string): Promise<void> {
    this.currentView = 'yaml';
    this.selectedTaskYaml = `Loading...`;
    if (pipelinerun != null && taskName != null) {
      let response = await lastValueFrom(this.tasksService.getTaskYaml(pipelinerun, taskName));
      this.selectedTaskYaml = response;
    }
  }

  async viewPipelineYaml(pipelinerun: string | null): Promise<void> {
    this.currentView = 'yaml';
    this.selectedTaskYaml = `Loading...`;
    if (pipelinerun != null) {
      let response = await lastValueFrom(this.tasksService.getPipelineYaml(pipelinerun));
      this.selectedTaskYaml = response;
    }
  }
}
